<template>
  <div>
    <div class="tab fontContent" v-model="modelValue">
      <div  v-for="(item,index) in list" :key="index" :class="modelValue==item.value?'active fontLitleTitle':null"  @click="$emit('change',item.value)">{{item.name}}</div>
    </div>    
  </div>
  
        

    
 
</template>
<script>
// 导入组件
// import { menu } from '@/api/userMG'

export default {
  name: 'tabs',
  // 注册组件
  components: {
    // activeName:this.modelValue
  },
  props:{
    modelValue:Number,
    list:{
      type:Array,
      default(){
        return []
      }
    }
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  data() {
    return {
   
    }
  },
  
  methods: {
        
  },
  created() {
    if(!this.modelValue)
    {
      if(this.list && this.list.length>0)
      {
        this.$emit('change',this.list[0].value)
      }
      
    }

  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {
    // 弹出登录成功
    
  }
}
</script>
<style scoped lang="less">
.tab
{
  // padding: 1rem 0;
  // border-bottom: 1px solid #D8D8D8;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 25px;
  background-color: #F8F8FAFF;
    border-radius: 18px;
    overflow: hidden;
    font-size: 14px;
    align-items: center;
    line-height: 14px;
  &>div
  {
    cursor: pointer;
    // padding: 10px 0;
    padding: 10px 37px;
    margin: 0 !important;
    
    color: #999999;
  }
  & .active
  {
    // color: $colorRed;
        border-radius: 1.8rem;
    color: #fff;
    // border-bottom: 0.2rem solid #EA0E1EFF;
    background-color: #EA0E1EFF;
  }
}

</style>



// WEBPACK FOOTER //
// src/view/exhibitionHall/switch.vue